// src/services/carousel.service.ts
import api from '../lib/api';

const API_URL = import.meta.env.VITE_API_URL;

// =============================
// GET ALL CAROUSEL IMAGES
// =============================
export async function fetchCarousel() {
  try {
    const res = await api.get(`${API_URL}/api/carousel`);
    return res.data; // [{id, order, imageUrl}]
  } catch (err) {
    console.error('Error loading carousel:', err);
    throw err;
  }
}

// =============================
// GET SINGLE CAROUSEL IMAGE
// =============================
export async function fetchCarouselImage(id: number) {
  try {
    const res = await api.get(`${API_URL}/api/carousel/${id}`);
    return res.data;
  } catch (err) {
    console.error('Error fetching carousel image:', err);
    throw err;
  }
}
